
import { services } from '@/models/service';
import ServicesList from '@/components/ServicesList.vue';

export default {
  metaInfo: {
    title: 'Vai Vem',
  },
  components: {
    ServicesList,
  },
  data: () => {
    return {
      services: services.filter(service => service.name == 'Confirmar Entrega'),
    };
  },
};
